import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fw-status-bar',
  template: require('./status-bar.component.html'),
  styles: [require('./status-bar.component.css')]
})
export class StatusBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/status-bar/status-bar.component.ts